import AuthorsByAlpComponent from '@/frontend/components/AuthorsByAlpComponent';
import AuthorsByPeriodComponent from '@/frontend/components/AuthorsByPeriodComponent';
import setMetas from '@/frontend/functions/setMetas';
export default {
  name: "AuthorsPage",
  components: {
    AuthorsByAlpComponent,
    AuthorsByPeriodComponent
  },

  data() {
    return {
      search: '',
      tabActive: 0
    };
  },

  created() {
    setMetas('authors');
  }

};